import React from 'react';
import AwardDetailCard from './components/AwardDetailIndex.jsx';

const AwardDetail = () => <AwardDetailCard />;

export default AwardDetail;
